import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import t360IntegrationStore from '~/view/screens/SettingsScreen/store/t360IntegrationStore';
import './style.scss';
import T360SettingFields from '~/view/screens/SettingsScreen/screens/Integrations/Integrations/components/T360SettingFields/T360SettingFields';

interface IProps {
  integrationId: number;
  disabled?: boolean;
}

const T360Settings: React.FC<IProps> = observer((props: IProps) => {
  const integrationSettingsTemp = useMemo(
    () => t360IntegrationStore.integrationsSettingsTemp[props.integrationId],
    [t360IntegrationStore.integrationsSettingsTemp]
  );

  const onOtherSettingsChanged = (settingName: string, settingValue: string | number) => {
    const settings = JSON.parse(JSON.stringify(integrationSettingsTemp));
    settings.settings[settingName] = settingValue;
    t360IntegrationStore.updateIntegrationSettingsTemp(props.integrationId, settings);
  };

  return (
    <div className="t360-screen-settings-container" key={`${props.integrationId}-settings`}>
      {Object.keys(integrationSettingsTemp.settings)
        .filter((settingName) => settingName !== 'timeslots' && settingName !== 'branches_mapping' && settingName !== 'authorization_url')
        .map((settingName: string) => (
          <T360SettingFields
            settingName={settingName}
            settingValue={integrationSettingsTemp.settings[settingName]}
            integrationId={props.integrationId}
            onChange={onOtherSettingsChanged}
            disabled={props.disabled}
          />
        ))}
    </div>
  );
});

export default T360Settings;
